module.exports = __webpack_public_path__ + "d64f6c4c4f853fb0cd1fb44d8d84fabb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-s.png
// module id = 2305
// module chunks = 0